import {Formik, ErrorMessage, Field, Form} from 'formik'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers/components/KTSVG'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {StaffAccountSchema} from '../../../../Utils/_helpers/ValidationSchema'
import {
  UpdateStaffAccount,
  CreateStaffAccount,
} from '../../../AdminPages/MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {CreateTeamProfile, updateTeamProfile} from '../Overview/OverviewSlice/TeamListSlice'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {boolean, object, string} from 'yup'

export const TeamMemberUserSchema = object().shape({
  email: string().email('Wrong email format').required('Email is required'),
  mobile: string().min(9).max(12),
  firstName: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .trim()
    .matches(/^\S/, 'Text field cannot start with a space')
    .required('First name is required'),
  lastName: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .trim()
    .matches(/^\S/, 'Text field cannot start with a space'),
  editting: boolean(),
  role: string().required('Role is required'),
})

const CreateUserProfile = ({show, handleClose, data, filter, page, setData}: any) => {
  const param: any = useLocation()
  const dispatch = useDispatch()

  const [teamData, setTeamData] = useState<any>({
    avatar: '',
    email: '',
    mobile: '',
    name: '',
    jobTitle: '',
    password: '',
    role: '',
    editting: false,
    isMobileVerified: false,
    isEmailVerified: true
  })

  const Owner = [
    {
      label: 'User Admin',
      detail: 'Admin has all ability with owner',
      value: 'FEuserAdmin',
    },
    {
      label: 'Manager',
      detail: 'Manager can do anything except export and delete subscriber',
      value: 'FEmanager',
    },
    {
      label: 'Staff Member',
      detail: 'Only show contacts + inbox messages that are assigned to you, or not assigned at all',
      value: 'FEstaff',
    },
    /* {
      label: 'Author',
      detail: "Author can't purchase or send",
      value: 'FEauthor',
     }, */
    {
      label: 'Author & Viewer',
      detail: 'Author & Viewer can only review subscriber and cannot purchase or send',
      value: 'FEviewer',
    },
  ]

  useEffect(() => {
    if (data?.editting == true) {
      setTeamData({
        avatar: data?.avatar,
        email: data?.email,
        mobile: data?.mobile,
        name: data?.name,
        role: data?.role,
        firstName: data?.firstName,
        lastName: data?.lastName,
        jobTitle: data?.jobTitle,
        id: data?._id,
        editting: true,
        isEmailVerified: data?.isEmailVerified,
        isMobileVerified: data?.isMobileVerified
      })
    }
  }, [show, data?.editting])

  return (
    <>
      <Modal
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
        scrollabel={'true'}
      >
        <div className='modal-header'>
          <h2>{`${data?.editting === false ? 'Add' : 'Update'} User `}</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
              setData({
                avatar: '',
                email: '',
                mobile: '',
                name: '',
                firstName: '',
                lastName: '',                
                password: '',
                role: '',
                jobTitle: '',
                isEmailVerified: true,
                isMobileVerified: false
              })
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 py-8'>
          <Formik
            enableReinitialize
            initialValues={data}
            validationSchema={TeamMemberUserSchema}
            onSubmit={(values: any) => {
              values.name = values.name.replace(/^\s+|\s+$/g, '')
              delete values.editting
              const finalData = new FormData()
              for (var key in values) {
                finalData.append(key, values[key])
              }
              if (data?._id !== undefined) {
                dispatch(updateTeamProfile({id: data?._id, data: finalData}))
                handleClose()
                setTeamData({
                  avatar: '',
                  email: '',
                  mobile: '',
                  name: '',
                  firstName: '',
                  lastName: '',
                  password: '',
                  role: '',
                  jobTitle: '',
                  editting: false,
                  isMobileVerified: false,
                  isEmailVerified: true
                })
              } else {
                dispatch(CreateTeamProfile({filter, data: finalData}))
                handleClose()
                setTeamData({
                  avatar: '',
                  email: '',
                  mobile: '',
                  name: '',
                  firstName: '',
                  lastName: '',
                  password: '',
                  role: '',
                  jobTitle: '',
                  editting: false,
                  isMobileVerified: false,
                  isEmailVerified: true
                })
              }
            }}
          >
            {({values, setFieldValue}: any) => (
              <Form>
                <div className='row mb-6'>
                  {values.avatar ? <label className='col-form-label fw-bold fs-6'>Avatar</label> : null}
                  
                  <div
                    className='image-input image-input-outline w-auto'
                    data-kt-image-input='true'
                  >
                    {typeof values.avatar !== 'object' ? (
                      <>
                      {/* <img
                        src={
                          values.avatar === ''
                            ? toAbsoluteUrl('/media/avatars/blank.png')
                            : values.avatar
                        }
                        alt='poster'
                        width={125}
                        height={125}
                      /> */}
                      </>
                    ) : (
                      <img
                        src={URL.createObjectURL(values.avatar)}
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    )}

                    {/* <label
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Change avatar'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-pencil-fill'
                        viewBox='0 0 16 16'
                      >
                        <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                      </svg>
                      <input
                        type='file'
                        name='avatar'
                        onChange={(event: any) => setFieldValue('avatar', event?.target.files[0])}
                        accept='.png, .jpg, .jpeg'
                      />
                    </label>

                    <span
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='remove'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Remove avatar'
                      onClick={(event: any) => setFieldValue('avatar', '')}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='25'
                        height='25'
                        fill='currentColor'
                        className='bi bi-x'
                        viewBox='0 0 16 16'
                      >
                        <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                      </svg>
                    </span> */}
                  </div>
                  {/* </div> */}
                </div>
                <ErrorMessage name='avatar'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='row mb-6'>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6'>First Name</label>
                    <Field
                      data-testid='inputFirstNameTeam'
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='firstName'
                      type='text'
                    />

                    <ErrorMessage name='firstName'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>

                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6'>Last Name</label>
                    <Field
                      data-testid='inputLastNameTeam'
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='lastName'
                      type='text'
                    />

                    <ErrorMessage name='lastName'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row mb-6'>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='email-team'>
                      Email
                    </label>
                    <Field
                      data-testid='inputEmailTeam'
                      id={'email-team'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='email'
                      type='email'
                    />

                    <ErrorMessage name='email'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='mobile-team'>
                      Phone
                    </label>
                    <Field
                      data-testid='inputPhoneTeam'
                      id={'mobile-team'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='mobile'
                      type='text'
                    />

                    <ErrorMessage name='mobile'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row mb-6'>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='job-team'>
                      Job Title
                    </label>
                    <Field
                      data-testid='inputJobTeam'
                      id={'job-team'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='jobTitle'
                      type='text'
                    />
                  </div>
                  <div className='d-flex gap-10 col-lg-6'>
                    <div className='d-flex flex-column'>
                      <label className='col-form-label fw-bold fs-6' htmlFor='email-verified-team'>
                        Email Verified
                      </label>
                      <div className='form-check form-switch'>
                        <Field
                          as='input'
                          type='checkbox'
                          id='email-verified-team'
                          name='isEmailVerified'
                          className='form-check-input'
                          data-testid='isEmailVerified'
                          checked={values.isEmailVerified}
                        />
                      </div>
                    </div>

                    <div className='d-flex flex-column'>
                      <label className='col-form-label fw-bold fs-6' htmlFor='mobile-verified-team'>
                        Mobile Verified
                      </label>
                      <div className='form-check form-switch'>
                        <Field
                          as='input'
                          type='checkbox'
                          id='mobile-verified-team'
                          name='isMobileVerified'
                          className='form-check-input'
                          data-testid='isMobileVerified'
                          checked={values.isMobileVerified}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* {!values.editting && (
                  <>
                    <label className='col-form-label fw-bold fs-6' htmlFor='password-team'>
                      Password
                    </label>
                    <Field
                      data-testid='inputPasswordTeam'
                      id={'password-team'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='password'
                      type='text'
                    />
                  </>
                )}

                <ErrorMessage name='password'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage> */}

                <label
                  className='col-form-label required fw-bold fs-6 mt-5'
                  htmlFor='whiteLabelSubdomain-staff'
                >
                  Role
                </label>

                {Owner?.map((key: any, index: any) => (
                  <div key={index}>
                    <div className='fv-row'>
                      <div className='form-check form-check-custom form-check-solid align-items-center'>
                        <input
                          className='form-check-input'
                          type='radio'
                          value={key.value}
                          name='role'
                          checked={values?.role == key.value}
                          onChange={(event: any) => {
                            setFieldValue('role', event?.target.value)
                          }}
                        />
                        <label
                          className='form-check-label ms-5'
                          htmlFor='kt_modal_update_role_option_0'
                        >
                          <div className='fw-bolder card-label fs-5 '>{key.label}</div>
                          <div className='text-gray-600'>{key.detail}</div>
                        </label>
                      </div>
                    </div>
                    <div className='separator separator-dashed my-5'></div>
                  </div>
                ))}

                <ErrorMessage name='role'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='modal-footer d-flex justify-content-center'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      className='btn btn-sm fw-500 gray_bg_purple w-100px p-3 py-4'
                      type='button'
                      onClick={() => {
                        handleClose()
                        setData({
                          avatar: '',
                          email: '',
                          mobile: '',
                          name: '',
                          password: '',
                          role: '',
                        })
                      }}
                    >
                      Cancel
                    </button>
                  </div>

                  <button data-testid='btnSaveUser' type='submit' className='btn btn-primary ml-2'>
                    Save & Send Invite
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default CreateUserProfile
